import Enumerator from '../global/Enumerator';

export const opportunitySelectionType = ['none', 'accepted', 'declined', 'not_discussed'];

export const opportunityTypes = [
  'credit_repair_agency',
  'car_buyers_advocacy',
  'car_asset_finance',
  'additional_car_warranty',
  'conveyancing_settlement_agency',
  'utility_connection_service',
  'landlord_protection',
  'home_and_contents',
  'risk_insurance',
  'investment_superannuation_and_financial_planning',
  'mortgage_protection_insurance',
  'health_cover',
  'estate_planning',
  'property_investment_services',
  'property_buyers_advocacy',
  'rental_agency',
  'invoice_financing',
  'professional_indemnity_cover',
  'comprehensive_car_insurance',
  'foreign_exchange_option',
  'deposit_guarantee',
  'building_services'
];

export class OpportunitySelectionType extends Enumerator {
  static default() {
    return this.of('none');
  }
}

OpportunitySelectionType.initEnum({
  none: {
    get title() {
      return 'No selection made';
    }
  },
  accepted: {
    get title() {
      return 'Clients wants to hear more';
    }
  },
  declined: {
    get title() {
      return 'Client declined the offer';
    }
  },
  not_discussed: {
    get title() {
      return 'Not discussed at this stage';
    }
  }
});

export class OpportunityType extends Enumerator {
  static default() {
    return this.of('credit_repair_agency');
  }
}

OpportunityType.initEnum({
  credit_repair_agency: {
    get title() {
      return 'Credit repair agency';
    }
  },
  car_buyers_advocacy: {
    get title() {
      return 'Car buyers advocacy';
    }
  },
  car_asset_finance: {
    get title() {
      return 'Car/asset finance';
    }
  },
  additional_car_warranty: {
    get title() {
      return 'Additional car warranty';
    }
  },
  conveyancing_settlement_agency: {
    get title() {
      return 'Conveyancing/settlement agency';
    }
  },
  utility_connection_service: {
    get title() {
      return 'Utility connection/relocation service';
    }
  },
  landlord_protection: {
    get title() {
      return 'General insurance: Landlord protection';
    }
  },
  home_and_contents: {
    get title() {
      return 'General insurance: Home and contents';
    }
  },
  risk_insurance: {
    get title() {
      return 'Risk insurance (life, TPD, income protection)';
    }
  },
  investment_superannuation_and_financial_planning: {
    get title() {
      return 'Investment, superannuation and financial planning';
    }
  },
  mortgage_protection_insurance: {
    get title() {
      return 'Mortgage protection insurance';
    }
  },
  health_cover: {
    get title() {
      return 'Health cover';
    }
  },
  estate_planning: {
    get title() {
      return 'Estate planning';
    }
  },
  property_investment_services: {
    get title() {
      return 'Property investment services';
    }
  },
  property_buyers_advocacy: {
    get title() {
      return 'Property buyer’s advocacy';
    }
  },
  rental_agency: {
    get title() {
      return 'Rental agency';
    }
  },
  invoice_financing: {
    get title() {
      return 'Invoice financing';
    }
  },
  professional_indemnity_cover: {
    get title() {
      return 'General Insurance: Professional indemnity cover';
    }
  },
  comprehensive_car_insurance: {
    get title() {
      return 'Comprehensive car insurance';
    }
  },
  foreign_exchange_option: {
    get title() {
      return 'Foreign exchange option';
    }
  },
  deposit_guarantee: {
    get title() {
      return 'Deposit guarantee';
    }
  },
  building_services: {
    get title() {
      return 'Building services';
    }
  }
});

export default {
  opportunitySelectionType,
  opportunityTypes,
  OpportunitySelectionType,
  OpportunityType
};
